export const login = {
  titleBox: {
    title1: "分享新的观点",
    title2: "助力美好生活",
    title3: "短信登录",
    title4: "账号密码",
    title5: "手机号",
    title6: "验证码",
    title7: "请输入手机号",
    title8: "请输入验证码",
    title9: "忘记密码?",
    title10: "登录",
    title11: "登录即代表您已阅读并同意",
    title12: "隐私政策",
    title13: "服务协议",
    title14: "立即注册",
    title15: "第三方登录",
    title16: "密码",
    title17: "请输入密码",
    title18: "已有账号",
    title19: "账号注册",
    title20: "注册即代表您已阅读并同意",
    title21: "注册",
    title22: "忘记密码",
    title23: "下一步",
    title24: "设置密码",
    title25: "确认密码",
    title26: "完成",
    title27: "返回登录",
    title28: "短信验证码",
    title29: "s 后获取",
    title30: "获取验证码",
    title31: "新密码",
    title32: "上一步",
    title33: "请先填写手机号",
    title34: "修改成功",
  },
};
